//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FloatingButton',
  data () {
    return {
      buttonStyle: {
        position: 'fixed',
        right: '25px',
        bottom: '100px',
        cursor: 'pointer',
        zIndex: 220,
        transition: 'none'
      },
      show: false
    }
  },
  methods: {
    onClick (e) {
      // 阻止事件冒泡，避免与拖拽冲突
      e.stopPropagation()
      this.$emit('click')
    }
  },
  watch: {
    '$route.path': function (val) {
      if (!val) {
        this.show = true
      } else {
        if (val !== '/bindLogin' && val !== '/h5' && val !== '/h5/schoolList') {
          this.show = true
        } else {
          this.show = false
        }
      }
    }
  },
  mounted () {
    // this.show = true
    // console.log('this.$router.path ==>', this.$router)
    // console.log('this.$route.path ==>', this.$route)
    // if (!this.$router.path) {
    //   this.show = false
    // } else {
    //   if (this.$router.path !== '/' && this.$router.path !== '/h5' && this.$router.path !== '/h5/schoolList') {
    //     this.show = false
    //   } else {
    //     this.show = true
    //   }
    // }
    const el = this.$el
    let isDragging = false
    let startX, startY, startLeft, startTop
    let hasMoved = false
    const startDrag = (clientX, clientY) => {
      isDragging = true
      hasMoved = false
      startX = clientX
      startY = clientY
      const rect = el.getBoundingClientRect()
      startLeft = rect.left
      startTop = rect.top
      // 禁用过渡动画
      el.style.transition = 'none'
    }
    const drag = (clientX, clientY) => {
      if (!isDragging) return
      const deltaX = clientX - startX
      const deltaY = clientY - startY
      // 判断是否有实质性移动
      if (Math.abs(deltaX) > 2 || Math.abs(deltaY) > 2) {
        hasMoved = true
        let newX = startLeft + deltaX
        let newY = startTop + deltaY
        // 边界检查
        const maxX = window.innerWidth - el.offsetWidth
        const maxY = window.innerHeight - el.offsetHeight
        newX = Math.max(0, Math.min(newX, maxX))
        newY = Math.max(0, Math.min(newY, maxY))
        el.style.right = 'auto'
        el.style.bottom = 'auto'
        el.style.left = newX + 'px'
        el.style.top = newY + 'px'
      }
    }
    const stopDrag = () => {
      isDragging = false
      // 恢复过渡动画
      el.style.transition = 'none'
    }
    // 触摸事件
    el.addEventListener('touchstart', (e) => {
      if (e.touches.length > 1) return
      startDrag(e.touches[0].clientX, e.touches[0].clientY)
    }, { passive: false })
    document.addEventListener('touchmove', (e) => {
      if (!isDragging || e.touches.length > 1) return
      drag(e.touches[0].clientX, e.touches[0].clientY)
    }, { passive: false })
    document.addEventListener('touchend', (e) => {
      stopDrag()
      // 如果发生了移动，则阻止点击事件
      if (hasMoved) {
        e.preventDefault()
      }
    }, { passive: false })
    // 鼠标事件
    el.addEventListener('mousedown', (e) => {
      startDrag(e.clientX, e.clientY)
    })
    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return
      drag(e.clientX, e.clientY)
    })
    document.addEventListener('mouseup', (e) => {
      stopDrag()
      // 如果发生了移动，则阻止点击事件
      if (hasMoved) {
        e.preventDefault()
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/draggableBtn.vue